import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from 'antd-mobile'
import { useLocation } from 'react-router'
import { disableBrowserBack } from '../../utils/helper'
const alert = Modal.alert

const UnSupport = () => {
    const { t } = useTranslation()
    const location = useLocation()

    useEffect(() => {
        disableBrowserBack()

        const show = alert(
            '',
            location.state?.message || t('message.unSupportDevice'),
            []
        )
        return () => {
            show.close()
        }
    }, [])

    return <div className="unsupport-device" />
}

export default UnSupport
